<template lang="pug">
.comments
    .comments-title
        h2 {{$t(`${baseTranslationPath}.comments_title`)}}

    .comment-field
        aiq-input(v-model="newComment"
            :placeholder="$t(`${baseTranslationPath}.drop_a_comment_placeholder`)"
            :max-length="250"
            :max-width="250"
            type="textarea"
            class="comment-input"
        )
        .comment-btn
            aiq-tooltip(effect="dark", placement="top", :content="$t(`${baseTranslationPath}.add_comment`)", :show-after="500")
              fa-icon(:icon="['fas', 'paper-plane']"  class="paper-plane-icon" @click="addComment(null, 'comment')")

    .comment-section(v-for="comment in comments" :key="comment.id")
        .comment
          .comment-header-wrapper
            .comment-header
                aiq-image(:src="avatar(comment)" :key="avatar(comment)")

            aiq-dropdown(
                  trigger="hover",
                  placement="top-start",
                  )
              template(v-slot:dropdown)
                aiq-dropdown-menu.message-menu
                  aiq-dropdown-item.message-menu-item.icon-item(v-if="canDelete(comment)" command="delete")
                    aiq-tooltip(effect="dark",
                          placement="top",
                          :content="$t(`global.delete`)",
                          :open-delay="500")
                      .msg-icon(@click="deleteComment(comment)")
                        fa-icon(:icon="['fas', 'trash-can']")
                  aiq-dropdown-item.message-menu-item.icon-item(command="reply")
                    aiq-tooltip(effect="dark",
                          placement="top",
                          :content="$t(`${baseTranslationPath}.reply_comment`)",
                          :open-delay="500")
                      .msg-icon(@click="toggleReplyField(comment)")
                        fa-icon(:icon="['fas', 'reply']")

              .comment-content
                  .comment-title
                      b.user {{ firstName(comment) }} {{ lastName(comment) }} {{ isDocumentRejected(comment) ? '(' + $t(`${baseTranslationPath}.rejected`) + ')' : '' }}
                      aiq-timeago.time-ago(:since="comment.created_at" :minTime="0")
                  span.msg-content {{comment.content}}

        .reply-section
            .replies
                .reply(v-for="reply in comment.replies" :key="reply.id")
                    .reply-comment
                        .comment-header-wrapper
                          .comment-header
                              aiq-image(:src="avatar(reply)" :key="avatar(reply)")

                          aiq-dropdown(
                                trigger="hover",
                                placement="top-start",
                                )
                            template(v-slot:dropdown)
                              aiq-dropdown-menu.message-menu
                                aiq-dropdown-item.message-menu-item.icon-item(v-if="canDelete(reply)" command="delete")
                                  aiq-tooltip(effect="dark",
                                        placement="top",
                                        :content="$t(`global.delete`)",
                                        :open-delay="500")
                                    .msg-icon(@click="deleteComment(reply)")
                                      fa-icon(:icon="['fas', 'trash-can']")

                            .reply-content
                                .comment-title
                                    b.user {{ firstName(reply) }} {{ lastName(reply) }}
                                    aiq-timeago.time-ago(:since="reply.created_at" :minTime="0")
                                span.msg-content {{reply.content}}

            .reply-field(v-if="comment.showReplyField")
                aiq-input(
                    v-model="replies[comment.id]"
                    :max-length="250"
                    :placeholder="$t(`${baseTranslationPath}.drop_a_reply_placeholder`)"
                    type="textarea"
                    class="comment-input"
                )
                .comment-btn
                    aiq-tooltip(effect="dark", placement="top", :content="$t(`${baseTranslationPath}.add_reply`)", :show-after="500")
                      fa-icon(:icon="['fas', 'paper-plane']" class="paper-plane-icon" @click="addComment(comment, 'reply', replies[comment.id])")



</template>
<script>
import { defaultProfile } from '@/libs';
import get from 'lodash/get';
import { mapState } from 'vuex';

export default {
  name: 'ControlListComments',
  data() {
    return {
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.control_list_manage',
      newComment: '',
      replies: {},
    };
  },
  props: {
    comments: {
      type: Array,
      default: () => [],
    },
    documentId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState({
      agent: state => state.agent.profile,
    }),
  },
  emits: ['addComment', 'deleteComment'],
  methods: {
    avatar(comment) {
      return get(comment, 'agent.picture.payload.url', defaultProfile.picture);
    },
    toggleReplyField(comment) {
      comment.showReplyField = !comment.showReplyField;
    },

    firstName(comment) {
      return get(comment, 'agent.profile.first_name', defaultProfile.first_name);
    },
    isDocumentRejected(comment) {
      return get(comment, 'payload.type') === 'reject';
    },

    canDelete(comment) {
      const agent_id = get(comment, 'agent_id');
      const logged_in_agent_id = get(this.agent, 'id');
      const isRejection = this.isDocumentRejected(comment);
      return (agent_id === logged_in_agent_id) && !isRejection;
    },

    lastName(comment) {
      return get(comment, 'agent.profile.last_name', defaultProfile.last_name);
    },
    addComment(comment, type, reply = '') {
      if (type === 'reply') {
        this.replies[comment.id] = '';
        const parent_id = get(comment, 'id');
        this.$emit('addComment', { id: this.documentId, comment: reply, parent_id });
      } else if (type === 'comment') {
        this.$emit('addComment', { id: this.documentId, comment: this.newComment });
        this.newComment = '';
      }
    },

    async confirmDelete() {
      try {
        await this.$aiq.confirm(
          this.$t(`${this.baseTranslationPath}.delete_confirm.title`),
          this.$t(`${this.baseTranslationPath}.delete_confirm.message`),
        );
        return true;
      } catch {
        return false;
      }
    },
    async deleteComment(comment) {
      if (!comment || !(await this.confirmDelete())) {
        return;
      }
      this.$emit('deleteComment', { id: this.documentId, comment_id: comment.id });
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'src/styles/aiq-variables.scss';

:deep(.el-textarea__inner) {
  height: 150px;
}

.comment-field {
  position: relative;
  width: 100%;
}

.reply-field {
  position: relative;
  width: 100%;
}

.comment-input :deep(textarea) {
  padding-right: 40px;
}

.paper-plane-icon {
    cursor: pointer;
    color: var(--aiq-bgc-list-item-selected);
    font-size:x-large;
    position: absolute;
    right: 40px;
    bottom: 30px;
    transition: color 0.2s;
}
.comment-delete {
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
}

.comments {
    margin-top: 20px;
    padding-bottom: 150px;
}

.comment-btn {
    padding-top: 20px;
    display: flex;
    justify-content: flex-end;
}

.comment-header {
    padding-top: 20px;
}
.comment-field {
    margin-top: 10px;
    padding-right: 20px;
}

.reply-section {
  margin-left: 60px;
  border-left: 2px solid var(--aiq-table-border);
  padding-left: 20px;
  margin-top: 10px;
}

.replies {
  display: flex;
  flex-direction: column;
}

.reply-field {
    margin-top: 10px;
    padding-left: 10px;
    padding-right:10px;
    width: 60% !important;
    justify-content: center;
}

.comment-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}


.comment {
    display: flex;
    margin-bottom: 10px;
    max-width:55%;
}

.comment-section {
    margin-top: 10px;
}

.comment-title {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    font-weight: 300;
    margin-bottom: 10px;
}

.time-ago {
    justify-content: flex-end;
    padding-right: 10px;
}
img {
      width: 28px;
      height: 28px;
      border-radius: 50%;
}

.reply-comment {
    margin-left: 40px;
    display: flex;
    align-items: flex-start;

}

.profile-name {
      white-space: nowrap;
      overflow: hidden;
      min-width: 0px;
      text-overflow: ellipsis;
      line-height: 28px;
}

.msg-content {
    padding-top: 20px;
    padding-left: 15px;
    padding-right: 15px;
    font-weight: 500;
    font-size:12px;
    padding-bottom: 20px;
    line-height: 20px;
    color: var(--aiq-bgc-list-item);
}

.reply-content {
    margin-bottom: 10px;
    margin-top: 10px;
    margin-left: 10px;
    border-radius: 10px;
    padding-top: 20px;
    padding-left: 15px;
    padding-right: 15px;
    min-height: 90px;
    max-height: 250px;
    color: var(--aiq-bgc-list-item);
    border: 1px solid var(--aiq-bgc-list-item-selected);
    background-color: var(--aiq-bgc-list-item-selected);
    overflow-y: auto;
    min-width: 450px;
    max-width: 700px;
}
.comment-content {
    margin-bottom: 10px;
    margin-top: 10px;
    margin-left: 10px;
    border-radius: 10px;
    padding-top: 20px;
    padding-left: 15px;
    padding-right: 15px;
    min-height: 90px;
    max-height: 250px;
    min-width: 450px;
    max-width: 700px;
    color: var(--aiq-bgc-list-item);
    border: 1px solid var(--aiq-bgc-list-item-selected);
    background-color: var(--aiq-bgc-list-item-selected);
    overflow-y: auto;
}
</style>